// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"552":"9079121e","557":"e1ac6eb3","615":"52ac9cda","722":"d5ce136b","835":"82a34358","993":"256d84cb"}[chunkId] + ".chunk.js";
};